import { render, staticRenderFns } from "./StarIcon.vue?vue&type=template&id=6fbcf8a3"
import script from "./StarIcon.vue?vue&type=script&lang=js"
export * from "./StarIcon.vue?vue&type=script&lang=js"
import style0 from "./StarIcon.vue?vue&type=style&index=0&id=6fbcf8a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports